export class DEVICE_CATEGORY {
    static readonly Portrait:       string = '00000263-1000-0000-0000-000000000001'
    static readonly Scanner:        string = '00000263-1000-0000-0000-000000000002'
    static readonly Radiology:      string = '00000263-1000-0000-0000-000000000004'        
    static readonly CBCTCarestream: string = '00000263-1000-0000-0000-000000000005';
    static readonly DSLRCamera:     string = '00000263-1000-0000-0000-000000000006';
    static readonly Printer:        string = '00000263-1000-0000-0000-000000000010'
    }